<div style="width: 100%; height: 100%">
  <app-orders-grid [autofit]="true" #grid (filterChange)="onFilterChange($event)"></app-orders-grid>
</div>
